import PrimaryButton from './PrimaryButton'
import SecondaryButton from './SecondaryButton'
import DeleteButton from './DeleteButton'

const StyledButtons = {
    SecondaryButton,
    PrimaryButton,
    DeleteButton
}

export default StyledButtons